import {CLEAR_MIX_TOTAL_REPORTS, FETCH_MIX_TOTAL_REPORTS, LIST_MIX_TOTAL_REPORTS, CLEAR_MIX_TOTAL_LOADING} from "./types";

const init = {
    isLoading: false,
    data: {},
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MIX_TOTAL_REPORTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_MIX_TOTAL_REPORTS:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_MIX_TOTAL_REPORTS:
            return {
                ...init
            };
        case CLEAR_MIX_TOTAL_LOADING:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state

    }
}
